export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function errorMessage(e) {
  const detail = e?.response?.data?.detail;
  if (Array.isArray(detail)) return detail.map((d) => `${(d.loc || []).slice(-1)[0]}: ${d.msg}`).join("; ");
  if (typeof detail === "string") return detail;
  if (e?.response?.status) return `Request failed (${e.response.status})`;
  return e?.message || "Network error — the server could not be reached";
}

export const fmtDate = (v) => (v ? new Date(v).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "—");
export const fmtDateTime = (v) => (v ? new Date(v).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");
export const fmtMoney = (v, cur = "GBP") =>
  v == null ? "—" : new Intl.NumberFormat("en-GB", { style: "currency", currency: cur, maximumFractionDigits: 0 }).format(v);
export const fullName = (c) => [c?.first_name, c?.last_name].filter(Boolean).join(" ");
